var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: { title: "Actknow Project" },
          model: {
            value: _vm.openActKnowledge,
            callback: function($$v) {
              _vm.openActKnowledge = $$v
            },
            expression: "openActKnowledge"
          }
        },
        [
          _c("p", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v("Do you want to Acknowledge Project?")
          ]),
          _c(
            "button",
            {
              staticClass: "button is-success",
              attrs: { slot: "action" },
              on: { click: _vm.acknowledge },
              slot: "action"
            },
            [_vm._v("Acknowledge")]
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("div", { staticClass: "columns is-multiline" }, [
            _c("div", { staticClass: "column is-12" }, [
              _c("h2", { staticClass: "title title-primary" }, [
                _vm._v(_vm._s(_vm.ProjectDetail.projectName))
              ])
            ]),
            _c("div", { staticClass: "column is-12" }, [
              _c("div", { staticClass: "is-pulled-left" }, [
                _c(
                  "span",
                  { class: _vm.createlbl(_vm.ProjectDetail.projectStatus) },
                  [_vm._v(_vm._s(_vm.ProjectDetail.projectStatus))]
                )
              ]),
              _c("div", { staticClass: "is-pulled-right" })
            ]),
            _c("div", { staticClass: "column is-12" })
          ]),
          _c(
            "tabs",
            [
              _c("tab", { attrs: { name: "Overview", selected: true } }, [
                _c("div", { staticClass: "columns is-desktop" }, [
                  _c("div", { staticClass: "column is-7" }, [
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column is-12 is-gapless is-multiline" },
                        [
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-12" })
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("ProjectID  : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(รหัสโปรเจ็ค)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.projectID))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Project Name : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(ชื่อโปรเจ็ค)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.projectName))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Partnumber : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(เลขที่ชิ้นส่วน)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.partNumber))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Partname : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(ชื่อชิ้นส่วน)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.partName))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Project Date : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(วันที่)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.projectDate))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Type Of Product : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(ประเภทสินค้า)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.typeOfProduct))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Material : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(วัสดุ)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.material))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Hardening : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(ความแข็ง)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.hardening))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Plating : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(ชุบ)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.plating))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Quantity : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(จำนวน)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.quantity))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Data Inspection : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(การตรวจสอบ)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.dataInspection))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Engineer Service On Site : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(บริการตรวจสอบหน้างาน)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.engineerService))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Description : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(รายละเอียด)")
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "column breakword is-9" },
                              [_vm._v(_vm._s(_vm.ProjectDetail.detail))]
                            )
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Job No. : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(หมายเลขงาน)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.jobNumber))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Invoice No : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(เลขใบกำกับภาษี)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(_vm._s(_vm.ProjectDetail.invoiceNo))
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Invoice Date : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(วันที่ใบกำกับภาษี)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("Date")(_vm.ProjectDetail.invoiceDate)
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Remind Date : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(วันครบรอบ)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("Date")(_vm.ProjectDetail.remindDate)
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Remind Date : "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(วันครบรอบ)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("Date")(_vm.ProjectDetail.remindDate)
                                )
                              )
                            ])
                          ]),
                          _vm.ProjectDetail.projectStatus === "Delete"
                            ? _c("div", { staticClass: "columns" }, [
                                _c("label", { staticClass: "column is-3" }, [
                                  _vm._v("Reject Remerk :  "),
                                  _c("br"),
                                  _c(
                                    "span",
                                    { staticClass: "text-small-gray" },
                                    [_vm._v("(หมายเหตุการลบ)")]
                                  )
                                ]),
                                _c("div", { staticClass: "column is-9" }, [
                                  _vm._v(
                                    _vm._s(_vm.ProjectDetail.projectRemark)
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "columns" }, [
                            _c("label", { staticClass: "column is-3" }, [
                              _vm._v("Create On :  "),
                              _c("br"),
                              _c("span", { staticClass: "text-small-gray" }, [
                                _vm._v("(วันที่สร้าง)")
                              ])
                            ]),
                            _c("div", { staticClass: "column is-9" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("DateTime")(_vm.ProjectDetail.createOn)
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("chat-full", {
                        attrs: {
                          persons: _vm.personInChat,
                          datas: _vm.messages,
                          roomName: _vm.ProjectDetail.projectID,
                          title: "Chat With Musubi",
                          cls: "is-success"
                        }
                      }),
                      _c("componentRelatedUser", {
                        attrs: { small: "Yes", data: _vm.allPersonInProject }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c(
                "tab",
                { attrs: { name: "Quotation/ใบเสนอราคา", selected: false } },
                [
                  _c("div", { staticClass: "columns" }, [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _vm.lastQU !== null &&
                        _vm.lastQU.quotationTask.length > 0
                          ? _c("article", { staticClass: "box-section" }, [
                              _c(
                                "div",
                                { staticClass: "message-section is-clearfix" },
                                [_c("p", [_vm._v("Current Quotation")])]
                              ),
                              _c("div", { staticClass: "content" }, [
                                _c(
                                  "h2",
                                  {
                                    staticClass: "title",
                                    staticStyle: { "margin-bottom": "0.5rem" }
                                  },
                                  [_vm._v(_vm._s(_vm.lastQU.quNo))]
                                ),
                                _c(
                                  "span",
                                  {
                                    class: _vm.createQUStatus(
                                      _vm.lastQU.quStatus
                                    ),
                                    staticStyle: { "margin-right": "10px" }
                                  },
                                  [_vm._v(_vm._s(_vm.lastQU.quStatus))]
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href:
                                        "https://api.musubi-thai.com/public/" +
                                        _vm.lastQU.quPath +
                                        _vm.lastQU.quotationFile
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-download" }),
                                    _vm._v(" Download")
                                  ]
                                ),
                                _c("br")
                              ])
                            ])
                          : [_c("h2", [_vm._v("Quotation is not accepted ")])]
                      ],
                      2
                    )
                  ]),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      this.$store.state.authUser.roleID === "Customer" &&
                      _vm.listQU.length > 0
                        ? _c("article", { staticClass: "box-section" }, [
                            _c(
                              "div",
                              { staticClass: "message-section is-clearfix" },
                              [_c("p", [_vm._v("Previous Quotation")])]
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c(
                                  "table",
                                  { staticClass: "table cleantable" },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Quotation No")]),
                                        _c("th", [_vm._v("Status")]),
                                        _c("th", [_vm._v("Revise")]),
                                        _c("th", [_vm._v("Create date")]),
                                        _c("th", [_vm._v("Lead time")]),
                                        _c(
                                          "th",
                                          { attrs: { align: "right" } },
                                          [_vm._v("Amount")]
                                        ),
                                        _c("th")
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.listQU, function(item, index) {
                                        return _c("tr", { key: index }, [
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.CreateUrlQUDetail(
                                                    item.quNo,
                                                    item.revise,
                                                    _vm.projectID
                                                  ),
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.quNo))]
                                            )
                                          ]),
                                          _c(
                                            "td",
                                            { attrs: { align: "center" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    "lbl is-status-" +
                                                    item.quStatus
                                                },
                                                [_vm._v(_vm._s(item.quStatus))]
                                              )
                                            ]
                                          ),
                                          _c("td", [
                                            _vm._v(
                                              "Version " +
                                                _vm._s(item.revise + 1)
                                            )
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("DateTime")(
                                                  item.createOn
                                                )
                                              )
                                            )
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("Number")(item.leadTime)
                                              )
                                            )
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("Currency")(item.amount)
                                              )
                                            )
                                          ]),
                                          _c("td", [
                                            _vm.ProjectDetail.projectStatus ===
                                            "Quoting"
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "button is-small is-success",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.acceptQU(
                                                          item.quNo,
                                                          item.revise
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-check"
                                                    }),
                                                    _vm._v("  Accept")
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ])
                                      })
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ]
              ),
              _c("tab", { attrs: { name: "Work Process", selected: false } }, [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _vm.lastQU !== null && _vm.lastQU.quotationTask.length > 0
                      ? _c(
                          "article",
                          { staticClass: "box-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "message-section is-clearfix" },
                              [_c("p", [_vm._v("Work Process")])]
                            ),
                            _c("div", { staticClass: "content" }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "title",
                                  staticStyle: { "margin-bottom": "0.5rem" }
                                },
                                [_vm._v(_vm._s(_vm.lastQU.quNo))]
                              ),
                              _c(
                                "span",
                                {
                                  class: _vm.createQUStatus(_vm.lastQU.quStatus)
                                },
                                [_vm._v(_vm._s(_vm.lastQU.quStatus))]
                              ),
                              _vm._v("  "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href:
                                      "https://api.musubi-thai.com/public/" +
                                      _vm.lastQU.quPath +
                                      _vm.lastQU.quotationFile
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-download" }),
                                  _vm._v(" Download")
                                ]
                              ),
                              _c("br"),
                              _c("br")
                            ]),
                            _c("grantchartQU", {
                              attrs: {
                                tasks: _vm.lastQU.quotationTask,
                                isShowActual: "Yes"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _vm.ProjectDetail.projectStatus === "Quoted" ||
              _vm.ProjectDetail.projectStatus === "Complete" ||
              _vm.ProjectDetail.projectStatus === "Working"
                ? _c("tab", { attrs: { name: "PO", selected: false } }, [
                    _vm.ProjectDetail.poName !== "" &&
                    _vm.ProjectDetail.poName !== null
                      ? _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column" }, [
                            _c("h3", { staticClass: "title" }, [
                              _vm._v("PO File")
                            ]),
                            _vm._v("\n            Download PO "),
                            _c("i", { staticClass: "fa fa-download" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href:
                                    "https://api.musubi-thai.com/public/" +
                                    _vm.ProjectDetail.poPath +
                                    _vm.ProjectDetail.poName
                                }
                              },
                              [_vm._v(_vm._s(_vm.ProjectDetail.poOrgName))]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm.ProjectDetail.projectStatus !== "Complete"
                      ? _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column" }, [
                            _c(
                              "article",
                              { staticClass: "box-section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "message-section is-clearfix"
                                  },
                                  [_c("p", [_vm._v("Upload PO")])]
                                ),
                                _c("upload", {
                                  ref: "upload",
                                  attrs: { isMultiple: false }
                                })
                              ],
                              1
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "button is-success",
                                attrs: { type: "button" },
                                on: { click: _vm.uploadPO }
                              },
                              [
                                _c("i", { staticClass: "fa fa-upload" }),
                                _vm._v("  Upload PO")
                              ]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _c(
                "tab",
                { attrs: { name: "Attachment/ไฟล์แนบ", selected: false } },
                [
                  _c("div", { staticClass: "columns" }, [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c("componentRelatedFile", {
                          attrs: { data: _vm.projectFiles }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "tab",
                { attrs: { name: "Team Profile/ทีม", selected: false } },
                [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c(
                        "article",
                        { staticClass: "box-section" },
                        [
                          _c(
                            "div",
                            { staticClass: "message-section is-clearfix" },
                            [_c("p", [_vm._v("Contact")])]
                          ),
                          _c("componentRelatedUser", {
                            attrs: { data: _vm.allPersonInProject }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14a0478c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a0478c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/customer/project/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-14a0478c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/customer/project/_id.vue
// module chunks = 1